"use strict";
var Observable_1 = require('../../Observable');
var sample_1 = require('../../operator/sample');
Observable_1.Observable.prototype.sample = sample_1.sample;
//# sourceMappingURL=sample.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/sample.js
// module id = 2657
// module chunks = 0